export default `
  mutation Authenticate($input: AuthenticateInput!) {
    authenticate(input: $input) {
      auth {
        token
        expiresAt
      }
      user {
        id
        firstName
        lastName
        email
        phone
        status
        createdAt
        updatedAt
      }
    }
  }
`;
